import { ComponentLikeType, SellerIntegrationType } from 'opensolar-common'
import { BaseThemeType, Button, styled, useMediaQuery } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import ProductTile from '../components/common/ProductTile'
import { getUserType } from '../userUtils'
import ContentSlider from './common/ContentSlider'
import { SectionWrapper } from './common/styles'

const MobileButtonWrapper = styled('div', { name: 'MobileButtonWrapper' })({
  margin: '20px 0px',
})

const ViewProductsButton = styled(Button, { name: 'ViewProductsButton' })(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}))
interface FeaturedProductsProps {
  brandName: string
  products: ComponentLikeType[]
  standCountries: string
  enabledSellerIntegrations?: SellerIntegrationType[]
  onProductClick?: (componentCode: string) => void
  onViewAllClick?: () => void
}

const splitStringCountries = (countries: string) => countries?.split(',').filter(Boolean)

export const FeaturedProducts = ({
  brandName,
  products,
  standCountries,
  onViewAllClick,
  onProductClick,
  enabledSellerIntegrations,
}: FeaturedProductsProps) => {
  const history = useHistory()
  const translate = useTranslate()
  let org = localStorage.getItem('org')
  org = org ? JSON.parse(org) : {}
  const userType = getUserType(org)
  const [showFeaturedProduct, setShowFeaturedProduct] = useState(false)
  const isMobile = useMediaQuery((theme: BaseThemeType) => theme.breakpoints.down('sm'))
  const standCountriesIncludes = standCountries ? splitStringCountries(standCountries) : []

  useEffect(() => {
    if (!enabledSellerIntegrations || enabledSellerIntegrations.length === 0) {
      setShowFeaturedProduct(false)
      return
    }

    const hasMatchingCountry = enabledSellerIntegrations.some((distributor: SellerIntegrationType) => {
      return distributor.countries.some((element) => standCountriesIncludes.includes(element))
    })

    setShowFeaturedProduct(hasMatchingCountry)
  }, [enabledSellerIntegrations, standCountriesIncludes])

  const onClickViewFeaturedProducts = useCallback(() => {
    onViewAllClick?.()
    history.push('/shop')
  }, [])

  if (!showFeaturedProduct || !products.length) return null

  return (
    <SectionWrapper>
      <ContentSlider
        cards={products}
        header={translate('Featured Products')}
        CTAButtonLeftSlider={
          !isMobile && (
            <ViewProductsButton variant="outlined" onClick={onClickViewFeaturedProducts}>
              {translate('View %{brandName} Products', { brandName })}
            </ViewProductsButton>
          )
        }
        render={(product, i) => (
          <ProductTile
            component={product}
            userType={userType}
            enabledSellerIntegrations={enabledSellerIntegrations}
            key={'product-' + i}
            onProductClick={onProductClick}
          />
        )}
      />
      {isMobile && (
        <MobileButtonWrapper>
          <ViewProductsButton variant="outlined" onClick={onClickViewFeaturedProducts}>
            {translate('View %{brandName} Products', { brandName })}
          </ViewProductsButton>
        </MobileButtonWrapper>
      )}
    </SectionWrapper>
  )
}
